import React from 'react';
import {ArrowUpIcon} from '@heroicons/react/24/outline';

export type SortField = 'due_date' | 'score';
export type SortOrder = 'asc' | 'desc';

interface SortProps {
  sortField: SortField;
  sortOrder: SortOrder;
  onSortFieldChange: (field: SortField) => void;
  onSortOrderToggle: () => void;
  hasScoreContract?: boolean;
}

const Sort: React.FC<SortProps> = ({
  sortField,
  sortOrder,
  onSortFieldChange,
  onSortOrderToggle,
  hasScoreContract = false,
}) => {
  const sortOptions = React.useMemo(() => {
    const options = [{value: 'due_date', label: '日付'}];
    if (hasScoreContract) {
      options.push({value: 'score', label: 'スコア'});
    }
    return options;
  }, [hasScoreContract]);

  return (
    <div className="flex items-center">
      <select
        value={sortField}
        onChange={(e) => onSortFieldChange(e.target.value as SortField)}
        className="w-32 block form-select appearance-none bg-white border-border rounded-l !rounded-r-none focus:outline-none text-sm text-foreground h-10"
      >
        {sortOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <button
        onClick={onSortOrderToggle}
        className={
          'border border-border rounded-r rounded-l-none hover:bg-background-hover hover:cursor-pointer flex items-center justify-center transition-all duration-200 w-16 h-10 bg-white'
        }
      >
        <div>
          <ArrowUpIcon
            className={`w-3 h-3 transition-transform duration-200 ${
              sortOrder === 'desc' ? 'rotate-180' : 'rotate-0'
            }`}
          />
        </div>
        <span className="text-sm ml-1">
          {sortOrder === 'desc' ? '降順' : '昇順'}
        </span>
      </button>
    </div>
  );
};

export default Sort;
